<template>
    <div>
        <div class="taxi-serve-nav">
            <div class="taxi-serve-nav-list" @click="checkTab(0)">
                <div :class="[tab?'':'active']">我的出行</div>
            </div>
            <div class="nav-list-line"></div>
            <div class="taxi-serve-nav-list" @click="checkTab(1)">
                <div :class="[tab?'active':'']">我的行程</div>
            </div>
        </div>
        <div :class="[tab?'taxi-serve-body':'taxi-serve-body active']">
            <van-form @submit="onSubmit">
                <div class="taxi-image">
                    <img src="../assets/taxi-serve.png">
                </div>
                <div class="my-trip-plan">
                    <div class="plan-text">
                        <van-field
                                v-model="boardingPoint"
                                label="出发地"
                                title-width="60px"
                                name="boardingPoint"
                                :left-icon=startAdd
                                placeholder=""
                                :rules="[{ required: true, message: '请填写出发地' }]"
                        />
                    </div>
                    <!--            <div class="direction-signs">-->
                    <!--                <img src="../assets/direction-signs.jpg">-->
                    <!--            </div>-->
                    <div class="plan-text">
                        <van-field
                                v-model="getoffPoint"
                                label="目的地"
                                name="getoffPoint"
                                :left-icon=endAdd
                                placeholder=""
                                :rules="[{ required: true, message: '请填写目的地' }]"
                        />
                    </div>
                    <div class="plan-text">
                        <van-field
                                v-model="date"
                                label="日期"
                                name="date"
                                readonly
                                :left-icon=planIcon
                                placeholder=""
                                is-link
                                @click="showPopup"
                                :rules="[{ required: true, message: '请填写出日期' }]"
                        />
                        <van-popup v-model="show"  position="bottom">
                            <van-datetime-picker
                                    v-model="currentDate"
                                    type="datetime"
                                    :min-date="minDate"
                                    :max-date="maxDate"
                                    @confirm="onConfirm"
                                    @cancel="onCancel"
                            />
                        </van-popup>
                    </div>
                </div>
                <div class="order-info taxi">
                        <van-field name="stepper" label="乘车人数">
                            <template #input>
                                <van-stepper v-model="stepper" />
                            </template>
                        </van-field>
                        <van-field
                                v-model="username"
                                name="username"
                                label="联系人："
                                placeholder="请输入联系人姓名"
                                :rules="[{ required: true, message: '请填写真实姓名' }]"
                        />
                        <van-field
                                v-model="weixin"
                                name="weixin"
                                label="微信号："
                                placeholder="以方便客服联络"
                                :rules="[{ required: true, message: '请填写微信号' }]"
                        />
                        <van-field
                                v-model="phone"
                                name="phone"
                                label="联系电话："
                                placeholder="请填写06或07开头的十位法国手机号"
                                :rules="[{ required: true, message: '请填写联系电话' }]"
                        />
                        <van-field
                                v-model="email"
                                name="email"
                                label="邮箱地址："
                                placeholder="以方便客服联络"
                                :rules="[{ required: true, message: '请填写邮箱地址' }]"
                        />
                        <van-field
                                v-model="message"
                                rows="1"
                                name="message"
                                autosize
                                label="备注："
                                type="textarea"
                                placeholder="请添加您的备注信息"
                        />
                        <div style="margin: 32px 16px 16px;">
                            <van-button round block type="info" native-type="submit">
                                确认下单
                            </van-button>
                        </div>
                </div>
                <div class="operation-flow">
                    <div class="operation-flow-title">
                        运作流程
                    </div>
                    <div class="operation-flow-icon">
                        <div class="flow-type-icon">
                            <img src="../assets/sub-no.png">
                            <div>提交订单</div>
                        </div>

                        <img class="connect-icon" src="../assets/content-line.png">

                        <div class="flow-type-icon">
                            <img src="../assets/serve-no.png">
                            <div>客服沟通</div>
                        </div>

                        <img class="connect-icon" src="../assets/content-line.png">

                        <div class="flow-type-icon">
                            <img src="../assets/taxi-no.png">
                            <div>公司出车</div>
                        </div>

                        <img class="connect-icon" src="../assets/content-line.png">

                        <div class="flow-type-icon">
                            <img src="../assets/order-no2.png">
                            <div>完成订单</div>
                        </div>
                    </div>
                </div>
            </van-form>
            <div class="taxi-serve-notice">
                <div class="serve-notice-body">
                    <div class="notice-title">四项须知，放心出行</div>
                    <div class="notice-text">
                        <div class="notice-text-list">
                            <span class="notic-min-icon">
                                <img src="../assets/xuzhi-a.png" style="top: 6px;width: 16px;">
                            </span>
                            <span>本次活动仅巴黎地区可用，并请提前一天预约</span>
                        </div>
                        <div class="notice-text-list">
                            <span class="notic-min-icon">
                                <img src="../assets/xuzhi-b.png" style="top: 5px;width: 16px">
                            </span>
                            <span>司机将全程佩戴口罩并每日对车内进行消毒</span>
                        </div>
                        <div class="notice-text-list">
                            <span class="notic-min-icon">
                                <img src="../assets/xuzhi-c.png" style="top: 3px;width: 21px">
                            </span>
                            <span>每位乘客将免费获取口罩一个</span>
                        </div>
                        <div class="notice-text-list">
                            <span class="notic-min-icon">
                                <img src="../assets/xuzhi-d.png" style="width: 20px;top: 2px">
                            </span>
                            <span>车内可购买免洗洗手液及护目镜</span>
                        </div>
                    </div>
                    <div class="mask-message-footer">
                        * 该活动最终解释权归一分钱所有
                    </div>
                </div>
            </div>
        </div>
        <div :class="[tab?'taxi-serve-body active':'taxi-serve-body']">
            <Loading v-if="isLoading"></Loading>
            <template v-if="!useTaxiServe">
                <div class="no-serves-list">
                    <img src="../assets/big-car.png">
                    <div>您尚未使用过出行服务</div>
                </div>
            </template>
            <template v-else>
                <div :class="[item.status > 4?'taxi-bill':'taxi-bill active']" v-for="(item,index) in taxiOrderList" :key="index" @click="goToInfo(item.id)">
                    <div class="taxi-bill-body">
                        <div class="bill-body-top">
                            <div class="bill-body-top-left">
                                <div>{{item.startTime}}</div>
                            </div>
                            <div class="bill-body-top-right">
                                <div class="point-of-departure">
                                    <div class="address-icon">
                                        <img src="../assets/start-add.png" v-if="item.status > 4">
                                        <img src="../assets/start-n.png" v-else>
                                    </div>
                                    <div class="detailed-address">
                                        <div class="detailed-address-ac">{{item.boardingPoint}}</div>
                                        <div class="detailed-address-nc"></div>
                                        <div :class="[item.status > 4?'taxi-bill-left-line':'taxi-bill-left-line active']"></div>
                                    </div>
                                </div>
                                <div class="to-destination">
                                    <div class="address-icon">
                                        <img src="../assets/end-add.png" v-if="item.status > 4">
                                        <img src="../assets/end-n.png" v-else>
                                    </div>
                                    <div class="detailed-address">
                                        <div class="detailed-address-ac">{{item.getoffPoint}}</div>
                                        <div class="detailed-address-nc"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { Toast } from 'vant';
    import { Stepper } from 'vant';
    import Vue from 'vue';
    import { DatetimePicker } from 'vant';
    import { Popup } from 'vant';
    import Loading from "../components/Loading";
    Vue.use(Popup);
    Vue.use(Stepper);
    Vue.use(DatetimePicker);
    export default {
        components: {Loading},
        data() {
            return {
                subKey:false,
                isLoading: true,
                useTaxiServe:true,
                taxiOrderList:[],
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(2025, 10, 1),
                currentDate: new Date(),
                date:'',
                show: false,
                boardingPoint:'',
                getoffPoint:'',
                stepper: 1,
                username:'',
                email:'',
                phone:'',
                weixin:'',
                message:'',
                startAdd:require("../assets/start-add.png"),
                endAdd:require("../assets/end-add.png"),
                planIcon:require("../assets/plan.png")
            };
        },
        computed:{
            tab: function (){
                return this.$store.state.taxiPageTab;
            }
        },

        beforeCreate() {
            this.$axios.get('/api/service/Rent/infoList/page/0').then(res => {
                if(res.data.code == 0){
                    this.taxiOrderList = res.data.data;
                    if(this.taxiOrderList.length == 0){
                        this.useTaxiServe = false;
                    }
                    //this.$store.commit('setTaxiOrderList', res.data.data);
                }else {
                    this.taxiOrderList = [];
                    //this.$store.commit('setTaxiOrderList', []);
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
        },
        methods:{
            showPopup() {
                this.show = true;
            },
            formatDate(date) {
                let m = (date.getMonth() + 1<10)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
                let d = (date.getDate()<10)?'0'+date.getDate():date.getDate();
                let h = (date.getHours()<10)?'0'+date.getHours():date.getHours();
                let f = (date.getMinutes()<10)?'0'+date.getMinutes():date.getMinutes();
                return `${date.getFullYear()}-${m}-${d} ${h}:${f}:00`;
            },
            onConfirm(date){
                this.show = false;
                this.date = this.formatDate(date);
            },
            onCancel(){
                this.show = false;
            },
            checkTab(currentTab){
                this.$store.commit('setTaxiPageTab',currentTab);
            },
            onSubmit(values){
                console.log(values);
                let data = {
                    'boardingPoint':values.boardingPoint,
                    'getoffPoint':values.getoffPoint,
                    'startTime':values.date,
                    'realName':values.username,
                    'mobile':values.phone,
                    'email':values.email,
                    'wechatId':values.weixin,
                    'fareCount':values.stepper,
                    'rentComment':values.message
                };
                if(!this.subKey){
                    this.subKey = true;
                    this.$axios.post('/api/service/Rent/addInfo',data,{
                    }).then(res => {
                        if(res.data.code){
                            Toast(res.data.data);
                            this.subKey = false;
                        }else {
                            this.$router.push({path:"/taxi-order-info",query:{id:res.data.data}});
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }
            },
            goToInfo(id){
                this.$router.push({path:"/taxi-order-info",query:{id:id}});
            },
        }
    };
</script>

<style scoped>
    .no-serves-list{
        text-align: center;padding-top: 210px;
    }
    .no-serves-list img{
        width: 290px
    }
    .no-serves-list div{
        font-size: 14px;color: #767171;padding-top: 40px;font-weight: 600;
    }
    .no-serves-list,.taxi-serve-body::before{
        content:" ";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color:#f3f3f3;/* 颜色自定义 */
        z-index:-100;/* 突然想到个游戏，是男人就下100层。。。 */
    }
    .van-stepper__minus,.van-stepper__plus{
        border-radius: 15px;
    }
    .order-info{
        padding: 13px 29px;background-color: #fff;margin-top: 7px;
    }
    .order-info >>> .van-stepper__minus{
        background-color: #f3f3f3;
    }
    .order-info >>> .van-stepper__plus{
        background-color: #f3f3f3;
    }
    .order-info >>> .van-stepper__input{
        background-color: #f3f3f3;
    }
    .order-info >>> span{
        color: #4a4a4a;
    }
    .order-info >>> .van-cell{
        border-bottom: 1px solid #e0e0e0;
        padding: 10px 0px;
    }
    .order-info >>> .van-button{
        width: 106px;font-size: 14px;color: black;background-color: #feda38;margin: 0 auto;border: 0;height: 33px;
        line-height: 33px;
    }
    .taxi-serve-body{display: none;padding-bottom: 20px;position: relative}
    .taxi-serve-body.active{display: block}
    .taxi-serve-nav{background-color: #fff}
    .taxi-serve-nav-list{
       display: inline-block;width: 49%;text-align: center;
    }
    .taxi-serve-nav-list div{
        width: 84px;
        margin: 0 auto;
        height: 20px;
        padding-bottom: 10px;
        font-size: 14px;color: #4a4a4a;
    }
    .taxi-serve-nav-list .active{border-bottom: 3px solid #FFDC3A;color: #FFDC3A}
    .taxi-serve-nav-list.left{
        border-right: 1px solid #999;
    }
    .nav-list-line{
        display: inline-block;
        border-right: 1px solid #d8d8d8;
        height: 25px;
        position: relative;
        top: 8px;
    }
    .my-trip-plan >>> .van-icon__image{
        margin-right: 4px;width: 15px;position: relative;top: -1px;
    }
    .plan-text >>> .van-field__label{
        width: 60px;
    }
    .taxi-image {
        width: 100%;font-size: 0;
    }
    .taxi-image img{
        width: 100%;
    }
    .direction-signs{
        position: absolute;
        z-index: 999;
        right: 37px;
        top: 50px;
    }
    .my-trip-plan{
        margin-top: 7px;
        background-color: #fff;
        padding-top: 20px;
        position: relative;
        padding-bottom: 14px;
    }
    .plan-text{
        padding:0 17px 6px 12px;
    }
    .plan-text .van-cell{
        background-color:#f7f5f5 ;
        border-radius: 6px;
        padding: 7px 0 8px 9px;
        color: #4a4a4a;
        font-size: 13px;
    }
    .van-icon__image{
        width: 2px;
    }
    #immediately-make{
        padding: 20px;text-align: center;
    }
    #immediately-make .van-button--normal{
        padding: 0 30px;font-size: 1.2rem;background-color: #e1a010;
        border: 0;
    }
    .operation-flow{
        margin-top: 10px;
        padding-bottom: 20px;
    }
    .operation-flow-title{
        padding: 20px 24px 12px;color: #4a4a4a;font-size: 14px;
    }
    .operation-flow-icon{
        padding: 0 10px;text-align: center;
    }
    .flow-type-icon{
        display: inline-block;
        text-align: center;
    }
    .operation-flow-icon .connect-icon{
        width: 42px;position: relative;top: -36px;
    }
    .flow-type-icon img{
        width: 37px;
    }
    .flow-type-icon div{
        color: #4a4a4a;
        font-size: 11px;margin-top: 4px;
    }
    .taxi-serve-notice{
        padding-bottom: 20px;
    }
    .taxi-serve-notice .notice-title{
        padding-bottom: 13px; font-size: 14px;color: #4a4a4a;padding-left: 3px;
    }
    .taxi-serve-notice .notice-text-list{
        font-size: 13px;padding-bottom: 10px;color: #4a4a4a;
    }
    .taxi-serve-notice .notice-text-list img{
        position: relative;
    }
    .taxi-bill{
        margin: 7px 20px;
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 0 13px 24px #ebedf0;
        border-left: 5px solid #fff;
    }
    .taxi-bill.active{
        border-left: 5px solid #FFDC3A;
    }
    .taxi-bill-body{
        height: 100%;
    }
    .taxi-bill-line{
        height: 20px;
        position: relative;
        top: 60%;
        background: #d2d227;
    }
    .bill-body-middle div{
        display: inline-block;
    }
    .bill-round-left{
        height: 40px;
        width: 40px;
        border-radius: 20px;
        background: #ebedf0;
        position: relative;
        left: -20px;top: -13px;
    }
    .bill-round-right{
        height: 40px;
        width: 40px;
        float: right;
        background: #ebedf0;
        border-radius: 20px;
        position: relative;
        right: -20px;top: -13px;
    }
    .bill-body-middle{
        height: 15px;
        background: #cece66;
    }
    .bill-body-top{
        padding: 20px 20px 0;
    }
    .bill-body-top-left{
        margin-bottom: 0.7rem;
    }
    .bill-body-top-right{
        position: relative;
    }
    .bill-body-bottom{
        padding: 20px;
        text-align: center;
        font-size: 1.2rem;
        font-weight: 600;
    }
    .address-icon{
        display: inline-block;
        padding: 0 3px;
        float: left;
        position: relative;
        z-index: 2;
        background-color: #fff;
    }
    .address-icon i{
        top:2px;margin-right: 8px;
    }
    .detailed-address{
        display: inline-block;width: 90%;position: relative;
    }
    .detailed-address div{
        word-wrap:break-word;
        word-break:normal;
    }
    .bill-body-top-left div{
        font-size: 14px;padding-left: 3px;
    }
    .bill-body-top-left span{
        font-size: 0.8rem;
        color: #999;
    }
    .detailed-address-ac{
        font-size: 14px;color: #4a4a4a;margin-left: 6px;padding-bottom: 20px;
    }
    .detailed-address-nc{
        color: #999;
    }
    .serve-notice-body{
        border-top: 1px solid #e0e0e0;
        margin: 0 21px;
        padding-top: 16px;
    }
    .notic-min-icon{
        display: inline-block;width: 25px;text-align: center;margin-right: 6px;
    }
    .taxi-bill .address-icon img{
        width: 12px;position: relative;
    }
    .to-destination .address-icon img{top: 1px}
    .point-of-departure .address-icon img{top: 1px}
    .taxi-bill-left-line img{
        width: 2px;margin-left: 8px;height: 20px;
    }
    .taxi-bill-left-line{
        width: 1px;
        border-right: 1px dashed #e7e5d9;
        height: 100%;
        left: -10px;
        top: 9px;
        position: absolute;
        z-index: 0;
    }
    .taxi-bill-left-line.active{
        border-right: 1px dashed #FFDC3A;
    }
    .taxi-serve-notice .mask-message-footer{
        margin-top: 13px;
        border-top: 1px solid #e0e0e0;
        padding-top: 7px;
        font-size: 12px;
        color: #9b9b9b;
    }
</style>
